export default "__VITE_ASSET__DCbAyHe5__"